import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import PaymentConfirmationComponent from './PaymentConfirmationComponent';
import { postTransaction } from 'src/actions/paymentAction';

export const mapStateToProps = (state: AppState) => {
    return {

    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentWillMount: (success: string | null, failed: string | null, paymentStatus: string | null, payuid: string | null, amount: string | null, axperror: string | null) => {
            dispatch(postTransaction(success, failed, paymentStatus, payuid, amount, axperror));
        }
    };
};

const PaymentConfirmationContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentConfirmationComponent);

export default PaymentConfirmationContainer;



// WEBPACK FOOTER //
// ./src/components/PaymentConfirmation/PaymentConfirmationContainer.tsx